<template>
  <div>
    <el-table
      size="mini"
      v-horizontal-scroll
      tooltip-effect="dark"
      style="width: 100%"
      :data="tableData"
      stripe
    >
      <el-table-column label="班级名称" prop="class_name"> </el-table-column>
      <el-table-column label="排课课程" prop="course_name"> </el-table-column>
      <el-table-column label="班级类型" prop="course_type"> </el-table-column>
      <el-table-column label="班级人数" prop="class_student_count">
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <div class="mwow-button primary" @click="toClassDetails(scope.row)">
            查看
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import { classlist } from "@/api/teacherManage";
export default {
  props: ["visible"],
  data() {
    return {
      tableData: [],
      page: 1,
      pageSize: 20,
      pageSizeArray: [20, 50, 100],
      total: 0,
    };
  },
  mounted() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.getlistData({
          page: 1,
          page_size: this.pageSize,
        });
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.getlistData({
        page: 1,
        page_size: this.pageSize,
      });
    }
  },
  methods: {
    getlistData(data) {
      classlist({
        page: data.page,
        page_size: data.page_size,
        staff_id: Number(this.$route.query.id),
      }).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = res.data.page;
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getlistData({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getlistData({
        page: 1,
        page_size: e,
      });
    },
    toClassDetails(e) {
      this.$router.push({
        name: "classManageDetail",
        query: {
          id: e.class_id,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
